import { render, staticRenderFns } from "./ButtonAdd.vue?vue&type=template&id=07f5dd31&"
import script from "./ButtonAdd.vue?vue&type=script&lang=js&"
export * from "./ButtonAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports